export default {
  data: () => ({
    selectedArea: "All",
    areasList: ["All"],
    totalCustomers: "",
    customerData: [],
    selectedReport: "No Orders (6 months)",
    reportsList: [
      "All",
      "No Orders (6 months)",
      "No Orders (3 months)",
      "No Orders (2 months)",
      "No Orders (Current Month)",
    ],
  }),
};
